import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useIsAuthenticated } from "@azure/msal-react";
import { useMsal } from "@azure/msal-react";

export const RequireAuth = ({ allowedRoles }) => {
  const location = useLocation();
  const isAuthenticated = useIsAuthenticated();
  const { accounts } = useMsal();

  return isAuthenticated &&
    (allowedRoles.length === 0 ||
      accounts[0]?.idTokenClaims?.roles?.find((role) =>
        allowedRoles?.includes(role),
      )) ? (
    <Outlet />
  ) : (
    <Navigate to="/" state={{ from: location }} replace />
  );
};
